import React, { useRef, useEffect, useState } from "react";
import "./investmentDetial.scss";
import Sidebar from "../../Sidebar/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader/Loader";
import noImg from "../../../../assets/noImage.jpeg";
import { toast } from "react-toastify";
import ImgPreview from "./ImgPreview";

function InvestmentDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const investment_id = location?.state?.facility;

  const [hideSvg, setHideSvg] = useState(false);
  const [facilityDetails, setFacilityDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dropdown, setDropdown] = useState(false);
  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [updateData, setUpdateData] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    plan_id: "",
    plan_name: "",
    amount: "",
    gst_18: "",
    amount_with_taxes: "",
    unlimited_bookings: "",
    access_loc: "",
    tournament_access: "",
    guest_pass: "",
    welcome_kit: "",
    booking_support: "",
    community_access: "",
    validity: "",
    status: "",
  });

  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  const fetchFacilityDetails = async () => {
    setLoading(true);
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/membership/get_facility_details?facility_id=${investment_id}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        setFacilityDetails(data);
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to fetch facility details");
    } finally {
      setLoading(false);
    }
  };
  const handleEditFacility = () => {
    navigate(`/admin/facility/edit`, {
      state: { facility: investment_id },
    });
  };

  const handleDeleteInvestment = async () => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/delete_investment_opportunity?inv_deal_id=${investment_id}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        navigate("/admin/investments");
        toast.success(data.message || "Investment deleted successfully");
      } else if (response.status === 403) {
        toast.error(data.detail);
        navigate("/admin/investments");
      } else {
        toast.error(data.detail);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to delete investment");
    }
  };

  const handleDropdown = (index) => {
    setDropdown(!dropdown);
    setDropdownIndex(index);
  };

  const handleStatus = async (event) => {
    const url = `https://ballersapi.ballerslife.co/api/v1/admin/membership/update_facility_onboarding_status?facility_id=${investment_id}&status=${event}`;
    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        fetchFacilityDetails();
        setUpdateStatus(true);
        setUpdateData(event);
        toast.success(data.message || "Status updated successfully");
        setDropdown(false);
      } else if (response.status === 403) {
        toast.error(data.detail);
        setDropdown(false);
      } else if (response.status === 422) {
        toast.error(data.detail[0].msg);
        setDropdown(false);
      } else {
        toast.error(data.detail);
        setDropdown(false);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Facility status not updated");
    }
  };

  const handleEditModalOpen = () => {
    setFormData((prev) => ({
      ...prev,
      plan_id: investment_id || "", // Auto-fill plan_id with investment_id
    }));
    setIsEditModalOpen(true);
  };

  const handleEditModalClose = () => {
    setIsEditModalOpen(false);
    setFormData({
      plan_id: "",
      plan_name: "",
      amount: "",
      gst_18: "",
      amount_with_taxes: "",
      unlimited_bookings: "",
      access_loc: "",
      tournament_access: "",
      guest_pass: "",
      welcome_kit: "",
      booking_support: "",
      community_access: "",
      validity: "",
      status: "",
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdatePlan = async () => {
    const accessToken = window.localStorage.getItem("access_token");
    if (!accessToken) {
      toast.error("Authentication token not found. Please log in again.");
      return;
    }

    // Validate required fields
    if (!formData.plan_id || !formData.plan_name) {
      toast.error("Plan ID and Plan Name are required.");
      return;
    }

    const url =
      "https://ballersapi.ballerslife.co/api/v1/memberships/membership/payment_plan/update";
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(data.message || "Payment plan updated successfully");
        handleEditModalClose();
      } else {
        toast.error(data.detail || "Failed to update payment plan");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to update payment plan");
    }
  };

  const inputRef = useRef(null);
  const [image, setImage] = useState(null);
  const [uploadBtn, setUploadBtn] = useState(false);
  const [imgPreview, setImgPreview] = useState(false);

  const uploadImage = () => {
    inputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setUploadBtn(true);
      setImgPreview(true);
    }
  };

  useEffect(() => {
    fetchFacilityDetails();
  }, []);

  const formatNumber = (num) => {
    let formattedNumber;
    if (num >= 1000000000) {
      formattedNumber = (num / 1000000000).toFixed(1) + "B";
    } else if (num >= 1000000) {
      formattedNumber = (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      formattedNumber = (num / 1000).toFixed(1) + "K";
    } else {
      return num?.toString();
    }
    if (
      formattedNumber.endsWith(".0K") ||
      formattedNumber.endsWith(".0M") ||
      formattedNumber.endsWith(".0B")
    ) {
      formattedNumber =
        formattedNumber.slice(0, -3) + formattedNumber.slice(-1);
    }
    return formattedNumber;
  };

  const formatClubTimings = (timings) => {
    if (!timings) return "Not available";
    return Object.entries(timings)
      .map(([days, { start_time, close_time }]) => {
        return `${days}: ${start_time} - ${close_time}`;
      })
      .join("<br />");
  };

  const formatSportsInfo = (sports) => {
    if (!sports) return "Not available";
    return Object.entries(sports)
      .map(([sport, { num_of_courts, min_players, max_players }]) => {
        return `${
          sport.charAt(0).toUpperCase() + sport.slice(1)
        } (No of courts - ${num_of_courts}, Min Players - ${min_players}, Max Players - ${max_players})`;
      })
      .join("<br />");
  };

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="goBackSvg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#FFBF00"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-chevron-left"
                onClick={() => navigate(-1)}
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </div>
            <div className="logoBtnMain">
              <div className="clubLogoMain">
                {facilityDetails.facility_image == null ? (
                  <img src={noImg} alt="" className="clubLogo" />
                ) : (
                  <img
                    src={facilityDetails.facility_image}
                    alt=""
                    className="clubLogo"
                  />
                )}
                <input
                  type="file"
                  ref={inputRef}
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
                {/* <div className="delSvg">
                  <div className="delSvgAdFacility">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ffbf00"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-upload"
                      style={{ cursor: "pointer" }}
                      onClick={uploadImage}
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="17 8 12 3 7 8" />
                      <line x1="12" x2="12" y1="3" y2="15" />
                    </svg>
                  </div>
                </div> */}
              </div>
              <div className="updateAndDelBtnMain">
                <div>
                  <div className="delSvg">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffbf00"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-upload"
                        style={{ cursor: "pointer" }}
                        onClick={uploadImage}
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="17 8 12 3 7 8" />
                        <line x1="12" x2="12" y1="3" y2="15" />
                      </svg>
                    </div>
                  </div>
                  <div className="delSvg">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="23"
                        height="23"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ffbf00"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-square-pen"
                        cursor="pointer"
                        onClick={handleEditFacility}
                      >
                        <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/* <button className="editPlanButton" onClick={handleEditModalOpen}>
                Edit Facility Details
              </button> */}
            </div>
            <div className="invOverviewMain">
              <div className="statusToRight">
                <div className="invOverviewCont">
                  <p className="invOverviewContFirst">DEAL ID :</p>
                  <p className="invOverviewContSecond">
                    {facilityDetails.facility_id}
                  </p>
                </div>
                <div className="invOverviewCont">
                  <p className="invOverviewContFirst">STATUS :</p>
                  <div className="statusDropdown">
                    <p className="invOverviewContSecond">
                      {updateStatus ? updateData : facilityDetails.status}
                    </p>
                    <p onClick={() => handleDropdown()} className="dropDownSvg">
                      {dropdown ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#f5f5f5"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-chevron-up"
                        >
                          <path d="m18 15-6-6-6 6" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#f5f5f5"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-chevron-down"
                        >
                          <path d="m6 9 6 6 6-6" />
                        </svg>
                      )}
                    </p>
                    {dropdown && (
                      <div
                        className="dropdownMainInv"
                        onClick={(event) =>
                          handleStatus(event.target.textContent)
                        }
                      >
                        <div className="dropdownCont">
                          <p>approved</p>
                        </div>
                        <div className="dropdownCont">
                          <p>under_review</p>
                        </div>
                        <div className="dropdownCont">
                          <p>declined</p>
                        </div>
                        <div className="dropdownCont">
                          <p>expired</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">FACILITY NAME :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.facility_name,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">CITY :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.city,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst"> LOCALITY :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.locality,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">COUNTRY :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.country,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">DIRECTION LINK:</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.direction_link,
                  }}
                  onClick={() =>
                    window.open(facilityDetails.direction_link, "_blank")
                  }
                  style={{ cursor: "pointer" }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">AVAILABLE SPORTS :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.available_sports?.join(", "),
                  }}
                />
              </div>
              <div className="invOverviewContThird">
                <p className="invOverviewContFirst">CLUB TIMINGS :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: formatClubTimings(facilityDetails.club_timings),
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">FACILITY TYPE :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.facility_type,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">FACILITY CONTACT :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: facilityDetails.facility_contact,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">SPORTS INFO :</p>
                <p
                  className="invOverviewContSecond inpInfoMainSec"
                  dangerouslySetInnerHTML={{
                    __html: formatSportsInfo(facilityDetails.sport_info),
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {imgPreview && (
        <ImgPreview
          setImgPreview={setImgPreview}
          image={image}
          setImage={setImage}
          uploadBtn={uploadBtn}
          setUploadBtn={setUploadBtn}
          fetchFacilityDetails={fetchFacilityDetails}
          facility_id={investment_id}
        />
      )}
      {isEditModalOpen && (
        <div className="modalExcelDownload">
          <div className="modalContentExcelDownloadEdit">
            <span
              className="closeModalExcelDownload"
              onClick={handleEditModalClose}
            >
              ×
            </span>
            <h2 className="modalTitleExcelDownload">Edit Payment Plan</h2>
            <div className="modalFieldExcelDownload">
              <label htmlFor="plan_id">Plan ID:</label>
              <input
                type="text"
                id="plan_id"
                name="plan_id"
                value={formData.plan_id}
                readOnly
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="plan_name">Plan Name:</label>
              <input
                type="text"
                id="plan_name"
                name="plan_name"
                value={formData.plan_name}
                onChange={handleFormChange}
                placeholder="Enter plan name"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="amount">Amount:</label>
              <input
                type="text"
                id="amount"
                name="amount"
                value={formData.amount}
                onChange={handleFormChange}
                placeholder="Enter amount"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="gst_18">GST (18%):</label>
              <input
                type="text"
                id="gst_18"
                name="gst_18"
                value={formData.gst_18}
                onChange={handleFormChange}
                placeholder="Enter GST amount"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="amount_with_taxes">Amount with Taxes:</label>
              <input
                type="text"
                id="amount_with_taxes"
                name="amount_with_taxes"
                value={formData.amount_with_taxes}
                onChange={handleFormChange}
                placeholder="Enter amount with taxes"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="unlimited_bookings">Unlimited Bookings:</label>
              <input
                type="text"
                id="unlimited_bookings"
                name="unlimited_bookings"
                value={formData.unlimited_bookings}
                onChange={handleFormChange}
                placeholder="e.g., true/false"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="access_loc">Access Location:</label>
              <input
                type="text"
                id="access_loc"
                name="access_loc"
                value={formData.access_loc}
                onChange={handleFormChange}
                placeholder="Enter access location"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="tournament_access">Tournament Access:</label>
              <input
                type="text"
                id="tournament_access"
                name="tournament_access"
                value={formData.tournament_access}
                onChange={handleFormChange}
                placeholder="e.g., true/false"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="guest_pass">Guest Pass:</label>
              <input
                type="text"
                id="guest_pass"
                name="guest_pass"
                value={formData.guest_pass}
                onChange={handleFormChange}
                placeholder="e.g., true/false"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="welcome_kit">Welcome Kit:</label>
              <input
                type="text"
                id="welcome_kit"
                name="welcome_kit"
                value={formData.welcome_kit}
                onChange={handleFormChange}
                placeholder="e.g., true/false"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="booking_support">Booking Support:</label>
              <input
                type="text"
                id="booking_support"
                name="booking_support"
                value={formData.booking_support}
                onChange={handleFormChange}
                placeholder="e.g., true/false"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="community_access">Community Access:</label>
              <input
                type="text"
                id="community_access"
                name="community_access"
                value={formData.community_access}
                onChange={handleFormChange}
                placeholder="e.g., true/false"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="validity">Validity:</label>
              <input
                type="text"
                id="validity"
                name="validity"
                value={formData.validity}
                onChange={handleFormChange}
                placeholder="Enter validity (e.g., 30 days)"
                className="modalInputExcelDownload"
              />
            </div>
            <div className="modalFieldExcelDownload">
              <label htmlFor="status">Status:</label>
              <input
                type="text"
                id="status"
                name="status"
                value={formData.status}
                onChange={handleFormChange}
                placeholder="Enter status"
                className="modalInputExcelDownload"
              />
            </div>
            <button
              className="downloadButtonExcelDownload"
              onClick={handleUpdatePlan}
            >
              Update Plan
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default InvestmentDetail;
